// @flow

import React, {Children} from 'react';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './table.component.module.styl';

import type {StatelessFunctionalComponent} from 'react';


const classes = hashedClasses(styles);

export const Subtitle: StatelessFunctionalComponent<{| children: React$Node |}> = props => (
    Children.count(props.children) ? <div className={classes.table__subtitle}>{props.children}</div> : null
);
